module.exports = "https://cdn-social.hiplatform.com/images/2b411336742f22c02a27b87755108ccc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand/logo.svg
// module id = oCkj
// module chunks = 0